import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import LocationsReservationsListView from "./locations_reservations-list.html";
import LocationsReservationsEditView from "./locations_reservations-edit.html";
import LocationsReservationsTimelineView from "./locations_reservations-timeline.html";


angular.module("locations_reservations", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('locations_reservations', {
                url: "/locations_reservations",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('locations_reservations.list', {
                url: "/list",
                controller: "LocationsReservationsListCtrl",
                template: LocationsReservationsListView,
                requiredPermission: ["LOCATION_RESERVATION_READ"]
            })            
            .state('locations_reservations.edit', {
                url: "/edit/:id",
                controller: "LocationsReservationsEditCtrl",
                template: LocationsReservationsEditView,
                requiredPermission: ["LOCATION_RESERVATION_READ"]
            }) 

            .state('locations_reservations.timeline', {
             url: "/timeline",
                controller: "LocationsReservationsTimelineCtrl",
                template: LocationsReservationsTimelineView,
                requiredPermission: ["LOCATION_RESERVATION_READ"],
                resolve: {
                    ConfigurationsGantt: ['Restangular', function (Restangular) {
                        return Restangular.all('Configurations').getList({ code: "", group_name: "GANTT" });
                    }]
                }
            })
    }])
;